import { render, staticRenderFns } from "./ParticipacaoValorTotalDespesasAbsoluto.vue?vue&type=template&id=64954d74&scoped=true&"
import script from "./ParticipacaoValorTotalDespesasAbsoluto.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoValorTotalDespesasAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64954d74",
  null
  
)

export default component.exports